<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="12">
      <el-simple-table :items="dataList" />
    </v-col>
  </v-row>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'DataProvider',
  components: {},
  props: {
    mandateData: [Array, Object],
  },
  computed: {
    dataList() {
      return [
        {
          title: 'Identifikavimo kodas',
          value: this.mandateData.mandate_code,
        },
        {
          title: 'Įregistravimo data',
          value: this.mandateData.registration_date,
        },
        {
          title: 'Prokūros rūšis',
          value: Enums.procurationKind.lt[this.mandateData.procuracy_type],
        },
        {
          title: 'Prokūros suteikiamos teisės',
          value: 'atstovaujamojo vardu ir dėl jo interesų atlikti visus teisinius veiksmus, susijusius su juridinio asmens (verslininko) verslu, be to atstovaujamojo vardu ir dėl jo interesų atlikti teisinius veiksmus teisme ir kitose ne teismo institucijose (Lietuvos Respublikos civilinio kodekso 2.176 straipsnio 1 ir 2 dalys)',
        },
        {
          title: 'Prokūra ribota',
          value: this.mandateData.procuracy_restricted ? 'Prokūra ribota' : false,
          hide: !this.mandateData.procuracy_restricted,
        },
        {
          title: 'Prokūros ribojimai',
          value: this.mandateData.procuracy_restriction,
          hide: !this.mandateData.procuracy_restricted,
        },
        {
          title: 'Terminas',
          value: Enums.terms.lt[this.mandateData.term] ?? '',
        },
        {
          title: 'Data apibrėžtas terminas',
          value: this.mandateData.term_date,
          hide: !this.mandateData.term_date,
        },
      ]
    },
  },
}
</script>

<style>
</style>